import { render } from "./PurchasePage.vue?vue&type=template&id=54992ae0"
import script from "./PurchasePage.vue?vue&type=script&lang=js"
export * from "./PurchasePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__